import { useCameraStateContext } from '../../../contexts/CameraContext';
import { useBotStateContext } from '../../../contexts/BotContext';
import { useAiChatPanelContext } from '../../../contexts/AiChatPanelContext';
import editorAction from '../../../actions/editorAction';
import ConversationAction from '../../../../chatbox/actions/ConversationAction';
import { createScenarioEngine } from '../engine/scenarioEngine';

const useScenarioEngine = ({ canvasBlocksRef, canvasCategoriesRef }) => {
    const { spawnPosition } = useAiChatPanelContext();
    const { panzone } = useCameraStateContext();
    const { addBlock, createPath, addVariable, updateBlockData, updateBlockDataJump, createCategory, deleteCategory, actionGetBotInformations, deleteBlock } = editorAction();
    const { variables, botName } = useBotStateContext();
    const { refreshDeeplyConversation } = ConversationAction();

    return createScenarioEngine({
        addBlock, createPath, addVariable, updateBlockData, updateBlockDataJump, createCategory, deleteCategory, deleteBlock,
        actionGetBotInformations, refreshDeeplyConversation, panzone, spawnPosition, variables, botName, canvasBlocksRef, canvasCategoriesRef,
    });
};

export default useScenarioEngine;
